import {
  AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild
} from '@angular/core';
import {ConfiguracoesMiaService} from "../../services/configuracoes-mia.service";
import {NgForm} from "@angular/forms";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {NotificacoesService} from "../../services/notificacoes.service";
import {
  FreeTrialConfirmationModalComponent
} from "../../free-trial-confirmation-modal/free-trial-confirmation-modal.component";
import { trigger, transition, style, animate } from '@angular/animations';
import {Router} from "@angular/router";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {MiaV3Service} from "../../services/mia-v3.service";
import {ProdutoService} from "../../services/produto.service";
import {NotificationService} from "@progress/kendo-angular-notification";
import {campoDoCatalogo, OpcaoCampoMia, opcoesDoCampo, GRUPOS_CONFIG_MIA, BLOCOS_CONFIG_MIA, camposDoMomento, campoDisponivel, dependenciaPendente, bloqueioDoCampo} from "../../../../server/domain/chatbot/CatalogoConfigMia";

declare var moment;

/** Grupos e campos vêm do catálogo compartilhado. */
interface SecaoMia {
  chave: string;
  bloco: string;
  rotulo: string;
  icone: string;
  desc: string;
  chaves: string[];
  soAdmin?: boolean;
}

/**
 * Opção de escolha da aba Comportamento. O mesmo texto alimenta o chip, a dica que
 * aparece no hover/foco e o cartão que volta em tela de toque — descrição de opção
 * não pode existir em três lugares diferentes e sair de sincronia. O texto mora no
 * catálogo (server/domain/chatbot/CatalogoConfigMia), junto do resto do campo.
 */
type OpcaoMia = OpcaoCampoMia;

@Component({
  selector: 'app-tela-config-atendente-virtual',
  templateUrl: './tela-config-atendente-virtual.component.html',
  styleUrls: ['./tela-config-atendente-virtual.component.scss']
})
export class TelaConfigAtendenteVirtualComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('frm') frm: NgForm;

  
  public configuracoes = {
    nome: '',
    status: 'DESATIVADA',
    telefonesTeste: '',
    modelo: '',
    comportamentoForaDoEscopo: '',
    comportamentoAudio: 'PEDIR_TEXTO',
    entenderImagens: true,
    responderSobreProdutos: false,
    divulgarLinkCardapio: false,
    entregaCardapio: 'LINK',
    imagemCardapioSoDoDia: false,
    montagemProduto: 'CHAT',
    pedirLocalizacao: true,
    rotuloBotaoCardapio: '',
    rodapeBotaoCardapio: '',
    instrucoesDaLoja: '',
    typebotConfigurado: false,
    escalarParaAtendente: true,
    mensagemEscalacao: '',
    tempoPausaMia: 1800,
    recuperarCarrinho: false,
    tempoRecuperarCarrinho: 20 * 60,
    dataInicioTrial: null,
    usarFluxoTypebot: false,
    idFluxoTypebot: null,
    idFluxoTypebotWhatsapp: null,
    idFluxoTypebotInstagram: null,
    publicIdFluxoInstagram: null,
    publicIdFluxoWhatsapp: null,
    modeloIaV3: '',
    usarMiaV3: false,
    carrinhoMiaV3: false,
    upsellFechamento: false,
    conversaCurta: false,
    repetirPedido: true,
    personalizarSaudacao: true,
    sugerirDadosHabituais: true,
    upsellItens: '',
    followupMiaV3: false,
    lembreteCarrinhoMinutos: 10,
    lembreteDescobertaMinutos: 20,
    toquesCarrinhoMinutos: '' as any,
    toquesDescobertaMinutos: '' as any,
  }
  /* Escada de toques do follow-up, editada como arrays (o payload vai cru e o
     servidor saneia e espelha o 1º toque no lembrete legado). Sem escada salva,
     deriva do lembrete único preservando o tempo que a loja já configurou. */
  toquesCarrinho: number[] = [2, 8, 25];
  toquesDescoberta: number[] = [1, 10];
  /* Preview espelha a 1ª variante do pool do servidor: o lojista vê o tom real
     de cada toque. O 1º do carrinho é o template de resumo, montado no HTML. */
  previewToquesCarrinho: Array<string | null> = [
    null,
    'Seu pedido continua montado aqui, é só fechar 😊',
    'Vou deixar seu pedido salvo por aqui, tá? Quando quiser fechar, é só me chamar 😊',
  ];
  previewToquesConversa: string[] = [
    'Oi! Ainda tô por aqui 😊 Quer ajuda pra escolher?',
    'Quer dar uma olhada no cardápio? Posso montar seu pedido por aqui mesmo 😊',
    'Vou ficar por aqui, tá? Quando quiser pedir, é só me chamar 😊',
  ];
  // seleção de modelo da Mia V3: visível só para admins do meucardápio
  ehAdminMeuCardapio = false;
  // checklist de ativação da Mia V3 (número cloud, recurso, flags, serviço)
  statusMiaV3: any = null;
  erroStatusMiaV3 = false;
  modelosIa = [
    { valor: '', rotulo: 'Padrão do serviço (GPT-6 Luna)' },
    { valor: 'claude-sonnet-5', rotulo: 'Claude Sonnet 5 — $3/$15 MTok' },
    { valor: 'claude-haiku-4-5', rotulo: 'Claude Haiku 4.5 — $1/$5 MTok (econômico)' },
    { valor: 'claude-opus-5', rotulo: 'Claude Opus 5 — $5/$25 MTok (mais capaz)' },
    { valor: 'gpt-6-luna', rotulo: 'GPT-6 Luna — $0,10/$0,50 MTok (OpenAI, econômico)' },
    { valor: 'gpt-5.6-luna', rotulo: 'GPT-5.6 Luna — $0,20/$1,20 MTok (OpenAI, econômico)' },
    { valor: 'gpt-5.6-terra', rotulo: 'GPT-5.6 Terra — $2/$12 MTok (OpenAI, balanceado)' },
    { valor: 'deepseek-v4-flash', rotulo: 'DeepSeek V4 Flash — $0,14/$0,28 MTok (Responses API, reasoning max)' },
  ];
  msgSucesso = '';
  // blocos de ajuda começam fechados: quem entra aqui vem configurar, não ler
  mostrarRecursos = false;
  mostrarFluxoPadrao = false;
  telefones: Array<string> = [];
  novoTelefone = '';

  /* ---------- seções: a conversa, do começo ao fim ----------
     Esta é a tela de configurações AVANÇADAS: quem chega aqui vem trocar um ajuste
     específico que ouviu falar, não ler a tela inteira. Por isso é uma página só,
     com trilho lateral e busca, em vez de abas — aba esconde 5/6 do conteúdo, some
     com o Ctrl+F e obriga a adivinhar em qual delas o ajuste mora. */
  secaoAtiva = 'chegada';

  /* ---------- abas: duas tarefas ----------
     OPERAÇÃO é ligar, testar e demonstrar; AJUSTES é como ela atende. Começa em
     Ajustes, que é o motivo da tela existir — salvo com a Mia desligada, quando
     o que o lojista precisa fazer primeiro está na Operação. */
  abaAtiva: 'operacao' | 'ajustes' = 'ajustes';
  readonly abas: Array<{ chave: 'operacao' | 'ajustes', rotulo: string, icone: string }> = [
    {chave: 'operacao', rotulo: 'Operação', icone: 'fa-power-off'},
    {chave: 'ajustes', rotulo: 'Ajustes', icone: 'fa-sliders-h'},
  ];

  /** A mesma configuração lida em texto corrido (tela Jeito de atender). */
  abraJeitoDeAtender() {
    this.router.navigateByUrl('/admin/chatbot/jeito-de-atender');
  }

  selecioneAba(chave: 'operacao' | 'ajustes') {
    if (this.abaAtiva === chave) return;
    this.abaAtiva = chave;
    // as seções não tinham layout enquanto a aba estava escondida: o observer
    // do trilho precisa ser montado de novo sobre elementos com altura
    if (chave === 'ajustes') setTimeout(() => this.observeSecoes());
  }
  private todasSecoes: SecaoMia[] = GRUPOS_CONFIG_MIA.map((grupo) => ({
    ...grupo, chaves: camposDoMomento(grupo.chave).map((campo) => campo.chave),
  }));

  /** Mantém os controles montados durante a busca, preservando o estado do formulário. */
  get secoesDaTela(): SecaoMia[] {
    return this.todasSecoes.filter((secao) => !secao.soAdmin || this.ehAdminMeuCardapio);
  }

  /** Navegação mostra apenas os grupos com resultados acessíveis. */
  get secoes(): SecaoMia[] {
    return this.todasSecoes.filter((secao) =>
      (!secao.soAdmin || this.ehAdminMeuCardapio) && this.secaoTemResultado(secao));
  }

  /** Os passos do pedido e o que vale a conversa toda, cada bloco com seu rótulo no trilho. */
  get blocos(): Array<{ chave: string, rotulo: string, secoes: SecaoMia[] }> {
    const secoes = this.secoes;
    return BLOCOS_CONFIG_MIA
      .map((bloco) => ({...bloco, secoes: secoes.filter((secao) => secao.bloco === bloco.chave)}))
      .filter((bloco) => bloco.secoes.length > 0);
  }

  /* O getter devolve um array novo a cada ciclo de detecção. Os itens são sempre
     os mesmos objetos de `todasSecoes`, então o *ngFor já não recriaria nada — mas
     foi exatamente essa combinação (getter + ngFor sem trackBy) que travou a
     primeira tela desta família, e a garantia custa uma linha. */
  trackPorChave(_indice: number, secao: SecaoMia): string {
    return secao.chave;
  }
  empresa: any;
  comportamentoForaDoEscopoEnum: string;
  notificacao: any;

  @ViewChild('freeTrialConfirmationModal', {static: false}) freeTrialConfirmationModal: FreeTrialConfirmationModalComponent;

  /*
  planosMia: PlanoMia[] = [
    {
      nome: "Básico",
      modelo: 'Basico',
      icone: "fas fa-circle",
      preco: 0,
      billingPeriod: 'mês',
      caracteristicas: [
        {texto: "Respostas da IA são dinâmicas", disponivel: true},
        {texto: "Memória limitada à última mensagem", disponivel: true},
        {texto: "Responde dúvidas dos clientes", disponivel: true},
        {texto: "Personalizar nome da Mia", disponivel: false},
        {texto: "Conhecimentos extras", disponivel: false},
        {texto: "Sem custo", disponivel: false}
      ],
      testeGratis: false
    },
    {
      nome: "Intermediário",
      modelo: 'Intermediario',
      icone: "fa fa-robot",
      preco: 49.90,
      billingPeriod: 'mês',
      caracteristicas: [
        {texto: "Respostas da IA são dinâmicas", disponivel: true},
        {texto: "Responde dúvidas dos clientes", disponivel: true},
        {texto: "Personalizar Nome da Mia", disponivel: true},
        {texto: "Memória das últimas 5 mensagens", disponivel: true},
        {texto: "Respostas mais contextuais", disponivel: true},
        {texto: "Conhecimentos extras", disponivel: true}
      ],
      testeGratis: true
    },
    {
      nome: "Ultra Inteligente (GPT-4)",
      preco: 99.90,
      icone: "fas fa-lightbulb",
      modelo: 'Avancado',
      billingPeriod: 'mês',
      caracteristicas: [
        {texto: "Respostas da IA são dinâmicas", disponivel: true},
        {texto: "Personalizar Nome da Mia", disponivel: true},
        {texto: "Memória de toda sessão de conversa", disponivel: true},
        {texto: "Entende perguntas mais complexas", disponivel: true},
        {texto: "Respostas mais contextuais", disponivel: true},
        {texto: "Conhecimentos extras", disponivel: true}
      ],
      testeGratis: true
    }
  ];
  planoEscolhido: any = {};
   */
  criandoFluxosTypebot: boolean;

  constructor(private configuracoesMiaService: ConfiguracoesMiaService, private constantsService: ConstantsService,
              private notificacoesService: NotificacoesService, private router: Router,
              private autorizacaoService: AutorizacaoService, private miaV3Service: MiaV3Service,
              private produtoService: ProdutoService, private notificationService: NotificationService,
              private elementRef: ElementRef, private zone: NgZone,
              private detectorDeMudancas: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.observeSecoes();
  }

  ngOnInit(): void {
      this.monteIndiceDeBusca();
      const usuario: any = this.autorizacaoService.getUser() || {};
      this.ehAdminMeuCardapio = !!(usuario.admin || usuario.superadmin);
      this.atualizeBusca();
      this.carregueStatusMiaV3();
      this.notificacoesService.carregue('Carrinho Abandonado').then((notificacao) => {
        if( !notificacao ) {
          notificacao = {
            ativada: true,
            fazerPreview: true
          };
        }

        this.notificacao = notificacao;
        //carrega a configuracao
        this.configuracoesMiaService.obtenhaConfiguracoes().then((configuracoes) => {
            this.configuracoes = configuracoes;
            if (configuracoes.status === 'DESATIVADA') this.abaAtiva = 'operacao';
            this.configuracoes.conversaCurta = !!configuracoes.conversaCurta;
            // coluna nova + tinyint do MySQL: sem valor explícito a oferta fica ligada
            this.configuracoes.repetirPedido =
              configuracoes.repetirPedido === undefined || configuracoes.repetirPedido === null
                ? true : !!configuracoes.repetirPedido;
            // seção "Perfil do cliente": as duas nascem ligadas (coluna nova/null = ON)
            this.configuracoes.personalizarSaudacao =
              configuracoes.personalizarSaudacao === undefined || configuracoes.personalizarSaudacao === null
                ? true : !!configuracoes.personalizarSaudacao;
            this.configuracoes.sugerirDadosHabituais =
              configuracoes.sugerirDadosHabituais === undefined || configuracoes.sugerirDadosHabituais === null
                ? true : !!configuracoes.sugerirDadosHabituais;
            // coluna nova + tinyint do MySQL: sem valor explícito o handoff fica
            // ligado (senão a tela salvaria "não escalar" sem ninguém pedir)
            this.configuracoes.escalarParaAtendente =
              configuracoes.escalarParaAtendente === undefined || configuracoes.escalarParaAtendente === null
                ? true
                : !!configuracoes.escalarParaAtendente;
            this.configuracoes.mensagemEscalacao = configuracoes.mensagemEscalacao || '';
            // coluna nova + tinyint: sem valor explícito o pedido de localização
            // fica ligado (comportamento que o checkout sempre teve)
            this.configuracoes.pedirLocalizacao =
              configuracoes.pedirLocalizacao === undefined || configuracoes.pedirLocalizacao === null
                ? true
                : !!configuracoes.pedirLocalizacao;
            // coluna nova: config antiga vem null e o servidor trata como pedir texto
            this.configuracoes.comportamentoAudio = configuracoes.comportamentoAudio || 'PEDIR_TEXTO';
            this.configuracoes.entregaCardapio = configuracoes.entregaCardapio || 'LINK';
            this.configuracoes.imagemCardapioSoDoDia = !!configuracoes.imagemCardapioSoDoDia;
            this.configuracoes.montagemProduto = configuracoes.montagemProduto || 'CHAT';
            // coluna nova + tinyint: sem valor explícito a visão fica ligada
            // (comportamento que a Mia sempre teve com imagens)
            this.configuracoes.entenderImagens =
              configuracoes.entenderImagens === undefined || configuracoes.entenderImagens === null
                ? true
                : !!configuracoes.entenderImagens;
            this.configuracoes.followupMiaV3 = !!configuracoes.followupMiaV3;
            this.configuracoes.lembreteCarrinhoMinutos =
              Number(configuracoes.lembreteCarrinhoMinutos) >= 1 && Number(configuracoes.lembreteCarrinhoMinutos) <= 60
                ? Number(configuracoes.lembreteCarrinhoMinutos) : 10;
            this.configuracoes.lembreteDescobertaMinutos =
              Number(configuracoes.lembreteDescobertaMinutos) >= 1 && Number(configuracoes.lembreteDescobertaMinutos) <= 60
                ? Number(configuracoes.lembreteDescobertaMinutos) : 20;
            this.carregueToquesDeFollowup();
            this.telefones = (this.configuracoes.telefonesTeste || '')
              .split(',').map((telefone) => telefone.trim()).filter((telefone) => !!telefone);
            this.carregueCardsUpsell();
            // o índice foi montado sobre os padrões, antes desta resposta chegar:
            // sem recalcular, o trilho conta ajustes de uma configuração que não é
            // a da loja (carrinho, follow-up e escalação mudam o que está no ar)
            this.atualizeBusca();
        });

        //carrega a empresa
        this.constantsService.empresa$.subscribe((empresa) => {
            if (empresa && empresa.id) {
                this.empresa = empresa;
            }
        });
      });
  }

  //rotula o estado da Mia no cabeçalho e na barra de ações
  get estadoAtual(): { chave: string, rotulo: string } {
    if (this.configuracoes.usarMiaV3 && this.configuracoes.status !== 'DESATIVADA') {
      if (this.erroStatusMiaV3) return {chave: 'off', rotulo: 'Status não verificado'};
      if (!this.statusMiaV3) return {chave: 'teste', rotulo: 'Verificando canal'};
      if (!this.statusMiaV3.canalWhatsappAtivo) return {chave: 'off', rotulo: 'Mia V3 não ativa'};
    }

    if (this.configuracoes.status === 'ATIVADA') {
      return {chave: 'ativa', rotulo: 'Em Produção'};
    }

    if (this.configuracoes.status === 'MODO_TESTE') {
      return {chave: 'teste', rotulo: 'Modo Teste'};
    }

    return {chave: 'off', rotulo: 'Desligada'};
  }

  /** Com a Mia desligada, nenhum ajuste desta tela tem efeito. */
  get miaDesligada(): boolean {
    return this.configuracoes.status === 'DESATIVADA';
  }

  /** Clique no trilho: rola até a seção. A marcação ativa quem devolve é o observer. */
  vaParaSecao(chave: string) {
    this.secaoAtiva = chave;
    const rolar = () => {
      const alvo = this.elementRef.nativeElement.querySelector('#mia-secao-' + chave);
      if (alvo) {
        alvo.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    };
    if (this.abaAtiva !== 'ajustes') {
      // a seção só existe com layout depois que a aba aparece
      this.selecioneAba('ajustes');
      setTimeout(rolar);
      return;
    }
    rolar();
  }

  /** Recalcula os campos e as dependências ao mudar o carrinho. */
  onCarrinhoMiaV3Change() {
    this.atualizeBusca();
  }

  /* ---------- blocos que começam recolhidos ----------
     Legado e Motor são encanamento: ocupam espaço sem serem o que o lojista veio
     fazer. Recolhidos, o cabeçalho continua dizendo como estão configurados. */
  blocosAbertos: { [chave: string]: boolean } = {
    legado: false,
    fluxo: false,
  };

  alterneBloco(chave: string) {
    this.blocosAbertos[chave] = !this.blocosAbertos[chave];
  }

  /* ---------- busca ----------
     O que faz uma tela de 30 ajustes ser usável não é a ordem, é conseguir digitar
     "troco" e achar. O índice sai do catálogo (rótulo + sinônimos), que é onde o
     vocabulário do lojista já está escrito. */
  busca = '';
  /** Chaves que continuam na tela. Set para o template consultar sem alocar nada. */
  chavesVisiveis: Set<string> = new Set();
  private indiceBusca: Array<{ chave: string, texto: string }> = [];

  private monteIndiceDeBusca() {
    const todas = this.todasSecoes
      .reduce((acc, secao) => acc.concat(secao.chaves), [] as string[]);
    this.indiceBusca = todas.map((chave) => {
      const campo = campoDoCatalogo(chave);
      const pedacos = [chave, campo?.rotulo || '', campo?.porQueMudar || '', campo?.explicacao || '', ...(campo?.sinonimos || [])];
      return {chave, texto: this.semAcento(pedacos.join(' '))};
    });
    this.atualizeBusca();
  }

  /** Compartilha a cadeia de dependências com as outras telas. */
  private campoDisponivel(chave: string): boolean {
    return campoDisponivel(chave, this.configuracoes);
  }

  resultadosBloqueados: Array<{rotulo: string; mensagem: string; alvo: string}> = [];

  abraCampo(chave: string) {
    this.limpeBusca();
    this.blocosAbertos.legado = true;
    this.blocosAbertos.fluxo = true;
    setTimeout(() => {
      const campo = campoDoCatalogo(chave);
      if (campo) this.vaParaSecao(campo.momento);
      const controle = this.elementRef.nativeElement.querySelector('[name="' + chave + '"]');
      if (controle) controle.focus({preventScroll: true});
    });
  }

  /** "Máximo" e "maximo" têm que achar a mesma coisa. */
  private semAcento(texto: string): string {
    return (texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  /* Recalculado por evento (digitar, ligar um toggle), nunca dentro de um getter
     que o template chama: 30 controles reavaliando a cada ciclo de detecção foi o
     que travou a primeira tentativa desta família de telas. */
  atualizeBusca() {
    const termos = this.semAcento(this.busca).split(/\s+/).filter(Boolean);
    const visiveis = new Set<string>();
    this.resultadosBloqueados = [];
    this.indiceBusca.forEach((item) => {
      const campo = campoDoCatalogo(item.chave);
      if (!campo || (campo.quemEdita === 'admin' && !this.ehAdminMeuCardapio)) return;
      if (!termos.every((termo) => item.texto.indexOf(termo) >= 0)) return;
      if (this.campoDisponivel(item.chave)) {
        visiveis.add(item.chave);
      } else if (termos.length) {
        const dependencia = dependenciaPendente(item.chave, this.configuracoes);
        const pai = campoDoCatalogo(dependencia.chave);
        this.resultadosBloqueados.push({rotulo: campo.rotulo,
          mensagem: bloqueioDoCampo(item.chave, this.configuracoes, this.ehAdminMeuCardapio),
          alvo: pai.quemEdita !== 'admin' || this.ehAdminMeuCardapio ? pai.chave : '',
        });
      }
    });
    this.chavesVisiveis = visiveis;
    this.opcoesAudio = opcoesDoCampo('comportamentoAudio', this.configuracoes);
    if (termos.length) {
      this.blocosAbertos.legado = true;
      this.blocosAbertos.fluxo = true;
    }
  }

  limpeBusca() {
    this.busca = '';
    this.atualizeBusca();
  }

  get buscando(): boolean {
    return !!this.semAcento(this.busca);
  }

  /** Quantos ajustes desta seção estão na tela — o número que o trilho mostra. */
  contagemDaSecao(secao: SecaoMia): number {
    return secao.chaves.filter((chave) => this.chavesVisiveis.has(chave)).length;
  }

  private secaoTemResultado(secao: SecaoMia): boolean {
    return this.contagemDaSecao(secao) > 0;
  }

  /** O trilho e a seção precisam concordar: um item que leva a nada é pior que
      um item a menos. As seções do HTML são fixas, então consultam por chave. */
  secaoNaTela(chave: string): boolean {
    const secao = this.todasSecoes.find((item) => item.chave === chave);
    return !!secao && (!secao.soAdmin || this.ehAdminMeuCardapio) && this.secaoTemResultado(secao);
  }

  get totalEncontrado(): number {
    return this.secoes.reduce((total, secao) => total + this.contagemDaSecao(secao), 0);
  }

  /* ---------- trilho: marcar a seção que está na tela ----------
     Roda fora do Angular e só entra de volta quando a seção realmente muda: um
     observer disparando detecção a cada pixel de rolagem trava a tela. */
  private observador: IntersectionObserver;

  /**
   * Quanto de tela o topo grudado ocupa: a navbar do painel (que o SCSS declara
   * em `--mia-navbar`) mais a altura real do cabeçalho. Medir em vez de repetir o
   * número do CSS é o que impede o trilho de marcar uma seção que está escondida
   * atrás do cabeçalho quando alguém mexer no padding dele.
   */
  private alturaDoTopoGrudado(): number {
    const host = this.elementRef.nativeElement;
    const navbar = parseInt(getComputedStyle(host).getPropertyValue('--mia-navbar'), 10) || 0;
    const cabecalho = host.querySelector('.mia-topo');
    return navbar + (cabecalho ? cabecalho.offsetHeight : 0) + 12;
  }

  private observeSecoes() {
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    const margemDoTopo = this.alturaDoTopoGrudado();

    if (this.observador) this.observador.disconnect();
    this.zone.runOutsideAngular(() => {
      this.observador = new IntersectionObserver((entradas) => {
        const visivel = entradas
          .filter((entrada) => entrada.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        const chave = visivel && visivel.target.id.replace('mia-secao-', '');

        if (chave && chave !== this.secaoAtiva) {
          this.zone.run(() => {
            this.secaoAtiva = chave;
            this.detectorDeMudancas.detectChanges();
          });
        }
      }, {rootMargin: `-${margemDoTopo}px 0px -55% 0px`});

      this.elementRef.nativeElement
        .querySelectorAll('.mia-secao')
        .forEach((secao: Element) => this.observador.observe(secao));
    });
  }

  ngOnDestroy(): void {
    if (this.observador) {
      this.observador.disconnect();
    }
  }

  // as opções (texto, ícone, resumo) vêm do catálogo: um lugar só para a tela, a busca e o diff
  opcoesStatus: OpcaoMia[] = opcoesDoCampo('status');
  opcoesForaDoEscopo: OpcaoMia[] = opcoesDoCampo('comportamentoForaDoEscopo');
  opcoesAudio: OpcaoMia[] = opcoesDoCampo('comportamentoAudio');
  opcoesEntregaCardapio: OpcaoMia[] = opcoesDoCampo('entregaCardapio');
  opcoesMontagemProduto: OpcaoMia[] = opcoesDoCampo('montagemProduto');

  /** Texto corrido da opção: é o que a dica mostra no hover e no foco de teclado. */
  dicaDaOpcao(opcao: OpcaoMia): string {
    return opcao.reforco ? `${opcao.descricao} ${opcao.reforco}` : opcao.descricao;
  }

  get opcaoStatus(): OpcaoMia {
    return this.opcoesStatus.find((opcao) => opcao.valor === this.configuracoes.status);
  }

  get opcaoForaDoEscopo(): OpcaoMia {
    return this.opcoesForaDoEscopo.find((opcao) => opcao.valor === this.configuracoes.comportamentoForaDoEscopo);
  }

  get opcaoAudio(): OpcaoMia {
    return this.opcoesAudio.find((opcao) => opcao.valor === this.configuracoes.comportamentoAudio);
  }

  /* Com o bloco fechado o cabeçalho precisa responder "como está configurado?"
     sozinho — senão recolher só esconde a informação. */
  get resumoLegado(): string {
    if (!this.configuracoes.recuperarCarrinho) {
      return 'desligado';
    }

    return `envia ${this.formatTime(this.configuracoes.tempoRecuperarCarrinho)} depois`;
  }

  get resumoFluxo(): string {
    if (!this.configuracoes.usarFluxoTypebot) {
      return 'desligado';
    }

    return this.configuracoes.typebotConfigurado ? 'menu guiado antes da Mia' : 'ligado, fluxos ainda não criados';
  }

  /** Exemplo de número no formato aceito (só dígitos), usando o WhatsApp da própria loja. */
  get exemploTelefone(): string {
    const whatsapp = this.empresa && this.empresa.numeroWhatsapp && this.empresa.numeroWhatsapp.whatsapp;
    return whatsapp ? `55${String(whatsapp).replace(/\D/g, '')}` : '5562999990000';
  }

  /** Salvo só com dígitos; na ficha aparece legível: +55 62 99999-0000. */
  formateTelefone(telefone: string): string {
    const digitos = String(telefone || '').replace(/\D/g, '');
    const brasil = digitos.match(/^55(\d{2})(\d{4,5})(\d{4})$/);
    if (brasil) return `+55 ${brasil[1]} ${brasil[2]}-${brasil[3]}`;
    return digitos ? `+${digitos}` : telefone;
  }

  adicioneTelefone() {
    // só dígitos: o WhatsApp manda o número sem "+", e "+55..." e "55..." na
    // lista eram o mesmo telefone contado duas vezes
    const telefone = (this.novoTelefone || '').replace(/\D/g, '');
    if (!telefone || this.telefones.indexOf(telefone) >= 0) {
      this.novoTelefone = '';
      return;
    }

    this.telefones = [...this.telefones, telefone];
    this.novoTelefone = '';
  }

  removaTelefone(telefone: string) {
    this.telefones = this.telefones.filter((item) => item !== telefone);
  }

  carregueStatusMiaV3() {
    this.erroStatusMiaV3 = false;
    this.configuracoesMiaService.obtenhaStatusMiaV3()
      .then((status: any) => {
        this.statusMiaV3 = status;
        // link do widget só existe com o recurso ativo (as rotas /miav3 exigem)
        if (this.ehAdminMeuCardapio && status?.recursoMiaV3Ativo && !this.widgetUrl) this.carregueLinkWidget();
      })
      .catch(() => {
        this.statusMiaV3 = null;
        this.erroStatusMiaV3 = true;
      });
  }

  // ==== widget de demonstração (link público por token) ====
  widgetUrl = '';
  widgetErro = '';
  widgetCarregando = false;
  widgetCopiado = false;
  regenerandoWidget = false;

  carregueLinkWidget() {
    this.widgetCarregando = true;
    this.widgetErro = '';
    this.miaV3Service.obtenhaLinkWidget()
      .then((resposta: any) => {
        this.widgetUrl = resposta?.url || '';
        if (!this.widgetUrl) this.widgetErro = resposta?.erro || 'Não consegui montar o link do widget.';
      })
      .catch(() => this.widgetErro = 'Não consegui carregar o link do widget.')
      .then(() => this.widgetCarregando = false);
  }

  copieLinkWidget() {
    if (!this.widgetUrl || !navigator.clipboard) return;
    navigator.clipboard.writeText(this.widgetUrl).then(() => {
      this.widgetCopiado = true;
      setTimeout(() => this.widgetCopiado = false, 2000);
    });
  }

  regenereTokenWidget() {
    if (this.regenerandoWidget) return;
    if (!confirm('Regenerar o link do widget? O link atual vai parar de funcionar na hora.')) return;

    this.regenerandoWidget = true;
    this.widgetErro = '';
    this.miaV3Service.regenereTokenWidget()
      .then((resposta: any) => {
        if (resposta?.url) this.widgetUrl = resposta.url;
        else this.widgetErro = resposta?.erro || 'Não consegui regenerar o link.';
      })
      .catch(() => this.widgetErro = 'Não consegui regenerar o link.')
      .then(() => this.regenerandoWidget = false);
  }

  /** Linhas do checklist de ativação, na ordem do pipeline. */
  get itensChecklistMiaV3(): Array<{ ok: boolean; rotulo: string; detalhe?: string }> {
    const status = this.statusMiaV3;
    if (!status) return [];
    return [
      { ok: status.canalWhatsappAtivo, rotulo: 'Canal WhatsApp disponível (API oficial ou extensão V4)',
        detalhe: (status.canaisWhatsapp || []).map(canal => canal.detalhe).join(' • ') || 'Conecte um número pela API oficial ou habilite o piloto da extensão V4.' },
      { ok: status.recursoMiaV3Ativo, rotulo: 'Recurso Mia V3 ativo na empresa',
        detalhe: status.recursoMiaV3Ativo ? undefined : 'ativar na Central Contratação (superadmin)' },
      { ok: status.usarMiaV3, rotulo: 'Mia V3 ligada (usarMiaV3)' },
      { ok: status.statusMia !== 'DESATIVADA' && !!status.statusMia, rotulo: 'Status da Mia',
        detalhe: status.statusMia || 'sem configuração' },
      { ok: status.servicoOnline, rotulo: 'Serviço mia-v3 no ar',
        detalhe: status.servicoOnline ? undefined : 'verifique o processo na porta 4330' },
      ...(status.telefoneCloudConectado ? [{ ok: status.carrinhoMiaV3, rotulo: 'Carrinho conversacional (API oficial)',
        detalhe: status.carrinhoMiaV3 ? undefined : 'desligado: a Mia só tira dúvidas' }] : []),
    ];
  }

  get checklistProntos(): number {
    return this.itensChecklistMiaV3.filter((item) => item.ok).length;
  }

  get checklistPercentual(): number {
    const total = this.itensChecklistMiaV3.length;
    return total ? Math.round((this.checklistProntos / total) * 100) : 0;
  }

  get checklistCompleto(): boolean {
    const total = this.itensChecklistMiaV3.length;
    return total > 0 && this.checklistProntos === total;
  }

  // ==== upsell no fechamento: cards dos itens escolhidos + busca no cardápio ====
  produtosUpsell: any[] = [];          // cards, na ordem de prioridade
  opcoesBuscaUpsell: any[] = [];       // resultado do autocomplete
  produtoUpsellSelecionado: any = null;
  carregandoCardsUpsell = false;
  private buscandoProdutoUpsell = false;
  private timerBuscaUpsell: any = null;

  /** Cards a partir dos ids salvos na config (nome, preço, imagem, elegibilidade). */
  carregueCardsUpsell() {
    let ids: number[] = [];
    try {
      const salvos = JSON.parse(this.configuracoes.upsellItens || '[]');
      ids = Array.isArray(salvos) ? salvos.map(Number).filter((id) => id > 0) : [];
    } catch (e) {
      ids = [];
    }
    if (!ids.length) {
      this.produtosUpsell = [];
      return;
    }
    this.atualizeCardsUpsell(ids);
  }

  private atualizeCardsUpsell(ids: number[]) {
    this.carregandoCardsUpsell = true;
    this.configuracoesMiaService.obtenhaItensUpsell(ids)
      .then((itens: any) => this.produtosUpsell = itens || [])
      .catch(() => {})
      .then(() => this.carregandoCardsUpsell = false);
  }

  searchProdutoUpsell(texto: string) {
    if (this.timerBuscaUpsell) clearTimeout(this.timerBuscaUpsell);
    this.timerBuscaUpsell = setTimeout(() => this.busqueProdutosUpsell(texto), 500);
  }

  busquePrimeiraVezUpsell() {
    if (!this.opcoesBuscaUpsell.length) this.busqueProdutosUpsell('');
  }

  private busqueProdutosUpsell(texto: string) {
    if (this.buscandoProdutoUpsell) return;
    this.buscandoProdutoUpsell = true;
    this.produtoService.autoComplete(texto, false, true, true)
      .then((produtos: any) => this.opcoesBuscaUpsell = produtos || [])
      .catch(() => {})
      .then(() => this.buscandoProdutoUpsell = false);
  }

  /** Escolha no dropdown vira card (máx. 3, sem repetir) e a seleção limpa. */
  adicioneProdutoUpsell(produto: any) {
    if (!produto || !produto.id) return;
    setTimeout(() => this.produtoUpsellSelecionado = null);
    if (this.produtosUpsell.length >= 3) return;
    if (this.produtosUpsell.some((item) => Number(item.id) === Number(produto.id))) return;

    // card provisório com os dados do autocomplete; o endpoint completa imagem/elegibilidade
    this.produtosUpsell = [...this.produtosUpsell,
      {id: produto.id, nome: produto.nome, preco: produto.valor, categoria: produto.categoria, disponivel: true, elegivel: true}];
    this.atualizeCardsUpsell(this.produtosUpsell.map((item) => Number(item.id)));
  }

  removaProdutoUpsell(produto: any) {
    this.produtosUpsell = this.produtosUpsell.filter((item) => Number(item.id) !== Number(produto.id));
  }

  /** Sobe o item uma posição (prioridade menor = oferecido primeiro). */
  subaPrioridadeUpsell(indice: number) {
    if (indice <= 0) return;
    const itens = [...this.produtosUpsell];
    [itens[indice - 1], itens[indice]] = [itens[indice], itens[indice - 1]];
    this.produtosUpsell = itens;
  }

  formatePrecoUpsell(valor: any): string {
    const preco = Number(valor);
    return isFinite(preco) && preco > 0 ? `R$ ${preco.toFixed(2).replace('.', ',')}` : '';
  }

  /** Preview do WhatsApp: usa o 1º item escolhido; sem escolha, um exemplo neutro. */
  get exemploUpsell(): { nome: string; preco: string } {
    const primeiro = this.produtosUpsell.find((item) => item.elegivel !== false);
    if (primeiro) {
      return {nome: primeiro.nome, preco: this.formatePrecoUpsell(primeiro.preco) || 'R$ 12,00'};
    }
    return {nome: 'Refrigerante 2L', preco: 'R$ 12,00'};
  }

  fechar() {

  }

  /* ---------- escada de toques do follow-up ---------- */

  carregueToquesDeFollowup() {
    this.toquesCarrinho = this.parseToques(this.configuracoes.toquesCarrinhoMinutos,
      Number(this.configuracoes.lembreteCarrinhoMinutos) || 10, [6, 23]);
    this.toquesDescoberta = this.parseToques(this.configuracoes.toquesDescobertaMinutos,
      Number(this.configuracoes.lembreteDescobertaMinutos) || 20, [9]);
  }

  /** JSON/array salvo, saneado; sem escada, deriva do lembrete único + ritmo padrão. */
  private parseToques(salvo: any, legado: number, gaps: number[]): number[] {
    let valores: any = salvo;
    if (typeof valores === 'string') {
      try { valores = JSON.parse(valores || '[]'); } catch { valores = []; }
    }
    const lista: number[] = [];
    for (const valor of (Array.isArray(valores) ? valores : [])) {
      const minutos = Number(valor);
      if (!Number.isInteger(minutos) || minutos < 1 || minutos > 60) continue;
      if (lista.length && minutos <= lista[lista.length - 1]) continue;
      lista.push(minutos);
      if (lista.length === 3) break;
    }
    if (lista.length) return lista;
    const derivada = [legado];
    for (const gap of gaps) {
      const minutos = Math.min(60, legado + gap);
      if (minutos > derivada[derivada.length - 1]) derivada.push(minutos);
    }
    return derivada;
  }

  adicioneToque(toques: number[]) {
    if (toques.length >= 3) return;
    const ultimo = Number(toques[toques.length - 1]) || 0;
    toques.push(Math.min(60, ultimo + (toques.length === 1 ? 6 : 17)));
  }

  removaToque(toques: number[], indice: number) {
    if (toques.length <= 1) return;
    toques.splice(indice, 1);
  }

  escadaValida(toques: number[]): boolean {
    if (!toques.length || toques.length > 3) return false;
    return toques.every((minutos, indice) => Number.isInteger(Number(minutos))
      && Number(minutos) >= 1 && Number(minutos) <= 60
      && (indice === 0 || Number(minutos) > Number(toques[indice - 1])));
  }

  /** Rótulo entre as bolhas do preview: tempo absoluto no 1º, delta nos demais. */
  marcadorDoToque(toques: number[], indice: number): string {
    const minutos = Number(toques[indice]) || 0;
    if (indice === 0) return `${minutos} min depois que o cliente para de responder`;
    const delta = minutos - (Number(toques[indice - 1]) || 0);
    return delta > 0 ? `+${delta} min sem resposta` : '';
  }

  trackPorIndice(indice: number): number {
    return indice;
  }

  onSubmit() {
    this.msgSucesso = '';
    if( !this.configuracoes.nome ) {
      return;
    }

    if (this.configuracoes.followupMiaV3
        && (!this.escadaValida(this.toquesCarrinho) || !this.escadaValida(this.toquesDescoberta))) {
      this.notifique('Os toques dos lembretes devem ser tempos crescentes entre 1 e 60 minutos.', 'error');
      return;
    }

    //número digitado sem clicar em "Adicionar" não pode se perder no salvamento
    this.adicioneTelefone();
    this.configuracoes.telefonesTeste = this.telefones.join(",");
    this.configuracoes.upsellItens = JSON.stringify(this.produtosUpsell.map((item) => Number(item.id)));
    this.configuracoes.toquesCarrinhoMinutos = this.toquesCarrinho.map(Number);
    this.configuracoes.toquesDescobertaMinutos = this.toquesDescoberta.map(Number);
    this.configuracoesMiaService.salveConfiguracoes(this.configuracoes).then((configuracaoSalva) => {
      this.configuracoes = configuracaoSalva;
      this.carregueToquesDeFollowup();
      // o salvo pode voltar diferente do enviado: o trilho segue o que voltou
      this.atualizeBusca();
      this.msgSucesso = 'Salvou configurações da Mia';
      this.notifique('Configurações da Mia salvas!', 'success');
      this.carregueStatusMiaV3();
    }).catch((erro) => {
      this.notifique(typeof erro === 'string' ? erro : 'Não consegui salvar as configurações.', 'error');
    });
  }

  // toast no topo: a barra fixa fica no rodapé e a confirmação passava batida
  private notifique(mensagem: string, tipo: 'success' | 'error') {
    this.notificationService.show({
      content: mensagem,
      type: {style: tipo, icon: true},
      position: {horizontal: 'center', vertical: 'top'},
      animation: {type: 'slide', duration: 200},
      hideAfter: 3500,
    });
  }

  formatTime(seconds: number): string {
    const duration = moment.duration(seconds, 'seconds');
    let formattedTime = '';

    if (duration.hours() > 0) {
      formattedTime += `${duration.hours()} ${this.pluralize(duration.hours(), 'hora', 'horas')} `;
    }

    if (duration.minutes() > 0 || duration.hours() > 0) {
      formattedTime += `${duration.minutes()} ${this.pluralize(duration.minutes(), 'minuto', 'minutos')} `;
    }

    if( duration.seconds() > 0 ) {
      formattedTime += `${duration.seconds()} ${this.pluralize(duration.seconds(), 'segundo', 'segundos')}`;
    }

    return formattedTime;
  }

  pluralize(quantity: number, singular: string, plural: string): string {
    return quantity === 1 ? singular : plural;
  }

  /*
  escolhiPlano(plano: PlanoMia) {
    this.freeTrialConfirmationModal.abraModal(plano);
  }
   */

  onConfirmSubscription(plano: any) {
    const configuracoesModificadas = { ...this.configuracoes };
    configuracoesModificadas.modelo = plano.modelo;

    this.configuracoesMiaService.atualizeMudouPlano(configuracoesModificadas).then( (resposta) => {
      this.configuracoes.modelo = plano.modelo;

      this.configuracoes.dataInicioTrial = new Date();

      //this.escolhendoPlano = false;
      //this.loading = false;
      this.freeTrialConfirmationModal.feche();
    });
  }

  onCancelSubscription() {
    //alert('Processo de assinatura cancelado');
    //this.router.navigate(['/home']);
  }

  mudarPlano() {
    //this.escolhendoPlano = true;
  }

  voltar() {
    //this.escolhendoPlano = false;
  }

  onUsarFluxoTypebotChange($event: any) {
    if (!this.configuracoes.usarFluxoTypebot) {
      return;
    }
  }

  editarFluxoTypebot(tipoDeFluxo: string, nomeFluxo: string) {
    if( tipoDeFluxo === 'whatsapp' ) {
      this.router.navigateByUrl('/admin/chatbot/editor-fluxo?id=' + 
        this.configuracoes.idFluxoTypebotWhatsapp + '&nome=' + nomeFluxo +
        '&publicId=' + this.configuracoes.publicIdFluxoWhatsapp);
    } else if( tipoDeFluxo === 'instagram' ) {
      this.router.navigateByUrl('/admin/chatbot/editor-fluxo?id=' + this.configuracoes.idFluxoTypebotInstagram + '&nome=' + nomeFluxo +
        '&publicId=' + this.configuracoes.publicIdFluxoInstagram);
    }
  }

  abrirTelaConfigTypebot() {
    this.router.navigate(['/admin/chatbot/config-typebot'], {
      queryParams: {
        configuracoes: JSON.stringify(this.configuracoes)
      }
    });
  }
}
